import {ord, ordString} from 'fp-ts/lib/Ord';
import {sortBy} from 'fp-ts/lib/Array';

class SortUtility {
  static sortElementsByKey = sortBy([ord.contramap(ordString, (element: JSX.Element) => element.key as string)]);
  static sortPropertiesByKey = (propertyName: string) =>
    sortBy([ord.contramap(ordString, (object: object) => object[propertyName] as string)]);
}

export default SortUtility;
